<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="m9.333 14-.95-.95 2.4-2.383h-7.45v-8h1.334v6.666h6.116l-2.4-2.4.934-.95L13.333 10l-4 4Z"
        />
    </svg>
</template>

<script setup lang="ts">
type SubDirectoryIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<SubDirectoryIconProps>();
</script>
